module.exports = __webpack_public_path__ + "static/Custom Web Automations-0b3b4b149d27f7976deac56da241d831.png";